import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkifyjs/html';
import Mark from 'mark.js';
import Modal from 'libs/components/modal';

export default function (data, parent) {
  let self = ko.mapping.fromJS(data);
  self.domId = ko.observable(isNaN(parseInt(self.id())) ? Kadenze.Util.generateUUID() : self.id());
  self.allowedAttachmentTypes = {image: '.jpg, .jpeg, .gif, .png, .svg', file: '.txt, .csv, .pdf, .cpp, .c, .js, .ck, .py, .mp3, .wav, .m4a, .mid, .ogg, .mov, .mp4, .m4v, .avi, .flv, .mpg, .ens, .als, .zip, .tar'};
  self.messages_mapping = {
    create: function(options) {
      return ko.mapping.fromJS(_.extend({}, options.data, {processed: false}));
    }
  };
  self.isPersisted = ko.computed(function () {
    return !isNaN(parseInt(self.id()));
  });
  self.recipientIds = ko.observable();
  self.messageEl = '#messages';
  self.attachmentModalEl = `#dz-modal-${self.domId()}`;
  self.participantMobileOptsEl = '#msngrParticipantMobileOpts';
  self.attachmentModalTitle = ko.observable();
  self.enterToSend = ko.observable(true);
  self.notice = {
    visible: ko.observable(false),
    message: ko.observable('')
  };
  self.messagesMeta = ko.observable();
  self.messagesLoading = ko.observable(false);
  self.computedNewMessage = ko.computed({
    read: function () {
      return self.new_message.body();
    },
    write: function (value) {
      self.new_message.body(s.stripTags(value));
    }
  }).extend({ maxLength: {message: 'Your message is too long. Please break it up into multiple messages.', params: 32000 } });
  self.computedLastMessage = ko.computed(function () {
    let message = '';
    if (self.messages().length > 0) {
      message = self.getMessageBodyOrAttachmentName(_.last(self.messages()));
    } else if (!_.isEmpty(self.last_message())) {
      message = s.stripTags(self.last_message());
    }
    return message;
  });
  self.computedLastMessageId = ko.computed(function () {
    return self.lastPersistedMessageId(self.messages().length - 1);
  });
  self.visibleParticipants = ko.computed(function () {
    return _.filter(self.participants(), function (participant) {
      return !participant._destroy();
    });
  });
  self.isGroupConversation = ko.computed(function () {
    return self.visibleParticipants().length > 1;
  });
  self.isSoloConversationBlocked = ko.computed(function () {
    return (self.visibleParticipants().length == 1) && self.visibleParticipants()[0].is_blocked();
  });
  self.isGroupConversationBlocked = ko.computed(function () {
    return (self.visibleParticipants().length > 1) && _.any(self.visibleParticipants(), function (participant) { return participant.is_blocked(); });
  });
  self.isSendingDisabled = ko.computed(function () {
    return self.isMessageInvalid();
  });

  self.addingParticipant = ko.observable(false);
  self.searchParticipant = ko.observable();
  self.searchParticipantResults = ko.observableArray([]);
  self.selectedSearchParticipants = ko.observableArray([]);
  self.selectedSearchParticipants.subscribe(function () {
    let participantIds = _.map(self.selectedSearchParticipants(), function (participant) {
      return participant.id();
    });
    self.recipientIds(participantIds.join(','));
    self.searchParticipant('');
  });
  self.searchParticipantFocus = ko.observable(false);
  self.participantPlaceholderText = ko.computed(function () {
    return !self.recipientIds() || self.recipientIds().length == 0 ? 'Type a name or an email address' : '';
  });
  self.editingSubject = ko.observable(false);
  self.editingSubject.subscribe(function (value) {
    if (!value) {
      self.save();
    } else {
      setTimeout(function() {
        let subjectEl = $('#group_name')[0];
        subjectEl.setSelectionRange(0, subjectEl.value.length);
      }, 50);
    }
  });
  self.computedSubject = ko.computed({
    read: function () {
      let subject;
      if (self.subject() != '-') {
        subject = self.subject();
      } else if (self.visibleParticipants().length > 3) {
        subject = _.map(self.visibleParticipants(), function (participant) {
          return participant.first_name();
        });
        subject = subject.join(', ');
      } else {
        subject = _.map(self.visibleParticipants(), function (participant) {
          return participant.full_name();
        });
        subject = subject.join(', ');
      }
      return subject;
    },
    write: function (value) {
      self.subject(s.stripTags(value) || '-');
    }
  });

  self.editSubject = function () {
    self.editingSubject(true);
  };

  self.saveSubject = function (item, event) {
    if (event.keyCode === 13) {
      item.editingSubject(false);
    }
    return true;
  };

  self.getMessages = _.memoize(function (prior_to) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.messenger_conversation_messages_path(self.id(), {prior: prior_to})
    });
  });

  self.addMessages = function (messages) {
    let was_scrolled_to_bottom = self.isScrolledToBottom();
    let mapped_messages = ko.mapping.fromJS(messages, self.messages_mapping);
    ko.utils.arrayPushAll(self.messages, mapped_messages());

    if (self.is_selected()) {
      if (was_scrolled_to_bottom)
        self.scrollToBottom();
    } else {
      self.is_read(false);
    }

    self.last_message(self.getMessageBodyOrAttachmentName(_.last(self.messages())));
    self.last_message_id(_.last(self.messages()).id());
    self.updated_at(_.last(self.messages()).created_at());
    self.deleteMessageCache();
  };

  self.loadMore = function () {
    if (!self.messagesLoading() && !self.messagesMeta().first_page()) {
      self.loadMessages(true);
    }
  };

  self.bindScrollEvent = function () {
    if ($(self.messageEl).length > 0) {
      $(self.messageEl).scroll(function() {
        if ($(self.messageEl).scrollTop() === 0) {
          self.loadMore();
        }
        return true;
      });
    } else {
      setTimeout(self.bindScrollEvent, 100);
    }
  };

  self.initMessageUI = function (message) {
    if (_.isEmpty(message.body()))
      return;

    if (!message.processed()) {
      let body = linkifyHtml(message.body());
      let links = linkify.find(message.body());

      _.each(links, function (link) {
        if (/\.(jpg|jpeg|gif|png|svg)$/.test(link.href)) {
          let imageTag = `<img class="msg-content__img mt1" src="${link.href}"/>`;
          body = body + imageTag;
        } else {
          let hiddenLink = linkifyHtml(link.href, {
            className: 'embed'
          });
          body = body + hiddenLink;
        }
      });

      message.body(body);

      $('a.embed', `#message_${message.id()}`).oembed();

      if (!_.isEmpty(parent.searchQuery())) {
        let context = document.querySelector(`#message_${message.id()}`);
        let instance = new Mark(context);
        instance.mark(parent.searchQuery());
      }

      message.processed(true);
    }
  };

  self.deleteMessageCache = function () {
    self.getMessages.cache = {};
  };

  self.resetNewMessage = function () {
    self.new_message.body('');
    self.new_message.message_attachments([]);
  };

  self.isScrolledToBottom = function () {
    let msgPanel = $(self.messageEl)[0];
    return msgPanel.scrollHeight - msgPanel.scrollTop === msgPanel.clientHeight;
  };

  self.scrollToBottom = function () {
    $(self.messageEl).animate({scrollTop: $(self.messageEl).prop('scrollHeight') + 9999}, 1000);
  };

  self.isMessageInvalid = function () {
    let client_errors = ko.validation.group([self.computedNewMessage], { deep: true });
    return client_errors().length > 0 || (_.isEmpty(s.trim(self.new_message.body())) && self.new_message.message_attachments().length === 0) || (!self.isPersisted() && _.isEmpty(self.recipientIds()));
  };

  self.sendOnEnter = function (item, event) {
    if ((event.keyCode === 13 && !event.shiftKey) && self.enterToSend() && !self.isSendingDisabled()) {
      if (self.isSoloConversationBlocked()) {
        self.unblockOnSend();
      } else {
        self.send();
      }
    } else {
      return true;
    }
  };

  self.sendOnClick = function () {
    if (self.isSoloConversationBlocked()) {
      self.unblockOnSend();
    } else if (!self.isSendingDisabled()) {
      self.send();
    }
  };

  self.send = function () {
    self.isPersisted() ? self.reply() : self.create();
  };

  self.reply = function () {
    let tempId = Kadenze.Util.generateUUID();
    self.new_message.id(tempId);
    self.new_message.created_at(moment().format(Kadenze.I18n.t('date.formats.js_default_with_zone')));
    self.updated_at(moment().format(Kadenze.I18n.t('date.formats.js_default_with_zone')));

    let message_obj = ko.mapping.toJS(self.new_message, {ignore: ['dzFile']});
    let message = ko.mapping.fromJS(_.extend({}, message_obj, {processed: false}));
    self.messages.push(message);

    let url = Kadenze.Routes.reply_messenger_conversation_path(self.id());

    if (self.dz && self.dz.files.length > 0) {
      self.dz.options.url = url;
      self.dz.on('sendingmultiple', function(file, response, formData) {
        if (!_.isEmpty(message_obj.body)) {
          formData.append('body', message_obj.body);
        }
      });
      self.dz.on('successmultiple', function(file, response) {
        let msg = _.find(self.messages(), function (message) {
          return message.id() == tempId;
        });
        if (msg) {
          let message_attachments = ko.mapping.fromJS(response.message.message_attachments);
          msg.message_attachments(message_attachments());
          msg.id(response.message.id);
        }
      });
      self.dz.processQueue();
    } else {
      let response = new Kadenze.AjaxRequest({
        type: 'POST',
        data: message_obj,
        url: url
      });

      response.done(function (data) {
        message.id(data.message.id);
      });

      response.fail(function(xhr, status, msg) {
        self.showNotice(xhr.responseJSON.errors.join(','));
      });
    }

    self.resetNewMessage();
    self.scrollToBottom();
    self.deleteMessageCache();
  };

  self.create = function () {
    let tempId = Kadenze.Util.generateUUID();
    self.new_message.id(tempId);
    self.new_message.created_at(moment().format(Kadenze.I18n.t('date.formats.js_default_with_zone')));

    let message_obj = ko.mapping.toJS(self.new_message, {ignore: ['dzFile']});
    let message = ko.mapping.fromJS(_.extend({}, message_obj, {processed: false}));
    self.messages.push(message);

    let url = Kadenze.Routes.messenger_conversations_path();

    if (self.dz && self.dz.files.length > 0) {
      self.dz.options.url = url;
      self.dz.on('sendingmultiple', function(file, response, formData) {
        formData.append('user_ids', self.recipientIds().split(','));
        if (!_.isEmpty(message_obj.body)) {
          formData.append('body', message_obj.body);
        }
      });
      self.dz.on('successmultiple', function(file, response) {
        self.update(response.conversation);
        parent.addConversation();
      });
      self.dz.processQueue();
    } else {
      let response = new Kadenze.AjaxRequest({
        type: 'POST',
        data: {user_ids: self.recipientIds().split(','), body: self.new_message.body()},
        url: url
      });

      response.done(function (response, status, xhr) {
        self.update(response.conversation);
        parent.addConversation();
      });

      response.fail(function(xhr, status, msg) {
        self.showNotice(xhr.responseJSON.errors.join(','));
      });
    }

    self.resetNewMessage();
    self.deleteMessageCache();
  };

  self.attach = function (type) {
    let initDZ = function (targetID) {
      if (!self.dz) {
        self.dz = self.initAttachmentDropZone(type, targetID);
      } else {
        let fileTypes = self.allowedAttachmentTypes[type];

        self.dz.options.acceptedFiles = fileTypes;
        self.dz.hiddenFileInput.accept = fileTypes;
      }
    };

    if (parent.mobileView()) {
      initDZ('#dz-mobile-attachment-drop')
      self.dz.hiddenFileInput.click()
    } else {
      self.attachmentModalTitle(`${(type == 'image') ?
          'Insert' :
          'Attach'} ${s.capitalize(type)}`)

      const $modal = $(self.attachmentModalEl).length ?
        $(self.attachmentModalEl) :
        Modal.for('messenger-attachment', { autoShow: false })

      ko.cleanNode($modal[0])

      ko.applyBindingsWithValidation(
        self,
        $modal[0],
        Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
      )

      $modal.on('shown.bs.modal', function (e) {
        initDZ(`#dz-attachment-drop-${self.domId()}`)
      })

      $modal.modal('show')
    }
  };

  self.update = function (conversation) {
    _.each(_.keys(conversation), function (key) {
      if (key == 'participants') {
        let participants_mapping = {
          create: function(options) {
            return ko.mapping.fromJS(_.extend({}, options.data, {_destroy: false}));
          }
        };
        self.participants(ko.unwrap(ko.mapping.fromJS(conversation[key], participants_mapping)));
      } else {
        if (ko.isObservable(self[key])) {
          if (_.isObject(conversation)) {
            self[key](ko.unwrap(ko.mapping.fromJS(conversation[key])));
          } else {
            self[key](conversation[key]);
          }
        }
      }
    });
  };

  self.select = function () {
    self.is_selected(true);
    self.is_read(true);
    self.messages([]);

    self.resetParticipantSearch();
    self.loadMessages();
    self.bindScrollEvent();
    self.scrollToBottom();
  };

  self.loadMessages = function (append) {
    let mp = null;

    if ($('#js-messages-loader').length > 0) {
      mp = new Mprogress({
        template: 4,
        start: true,
        parent: '#js-messages-loader'
      });
    }

    self.messagesLoading(true);

    let priorTo = self.messages()[0] ? self.messages()[0].id() : null;
    let response = self.getMessages(priorTo);

    response.done(function (data) {
      self.messagesMeta(ko.mapping.fromJS(data.meta));

      let mapped_messages = ko.mapping.fromJS(data.messages, self.messages_mapping);

      if (append) {
        _.each(mapped_messages(), function (message) {
          if (_.findIndex(self.messages(), function (m) { return m.id() === message.id(); }) === -1) {
            self.messages.unshift(message);
          }
        });
        //Scroll to the first message
        $(self.messageEl).scrollTop($(self.messageEl).scrollTop() + ($(`#message_${self.messages()[0].id()}`).position() || {}).top);
      } else {
        self.messages(mapped_messages().reverse());
        self.updated_at(_.last(self.messages()).created_at());
        self.scrollToBottom();
        if ($(self.messageEl).length > 0 && !$(self.messageEl).hasScrollBar()) {
          self.loadMessages(true);
        }
      }
    });

    response.fail(function(xhr, status, msg) {
      self.deleteMessageCache();
      new Kadenze.Notice.error({message: 'There was an error loading messages for this conversation. Please contact an administrator.'});
    });

    response.always(function () {
      if (($('#js-messages-loader').length > 0) && mp != null) {
        mp.end();
      }

      self.messagesLoading(false);
    });
  };

  self.unselect = function () {
    self.is_selected(false);
  };

  self.trash = function () {
    let index = parent.visibleConversations().indexOf(self);
    let wasSelected = self.is_selected();

    self.unselect();
    self._destroy(true);

    let response = new Kadenze.AjaxRequest({
      type: 'DELETE',
      url: Kadenze.Routes.messenger_conversation_path(self.id())
    });

    response.done(function (response, status, xhr) {
      //TODO
    });

    response.fail(function(xhr, status, msg) {
      //TODO
    });

    if (wasSelected)
      parent.showNextConversation(index);
  };

  self.leave = function () {
    let index = parent.visibleConversations().indexOf(self);
    let wasSelected = self.is_selected();

    self.unselect();
    self._destroy(true);

    let response = new Kadenze.AjaxRequest({
      type: 'DELETE',
      url: Kadenze.Routes.leave_messenger_conversation_participants_path(self.id())
    });

    response.done(function (response, status, xhr) {
      //TODO
    });

    response.fail(function(xhr, status, msg) {
      //TODO
    });

    if (wasSelected)
      parent.showNextConversation(index);
  };

  self.save = function () {
    let response = new Kadenze.AjaxRequest({
      type: 'PATCH',
      data: {subject: self.subject()},
      url: Kadenze.Routes.messenger_conversation_path(self.id())
    });

    response.done(function (data) {
      //TODO
    });

    response.fail(function(xhr, status, msg) {
      //TODO
    });
  };

  self.showOptionsMenu = function (item, event) {
    event.stopPropagation();
    $(`#optMenu-${item.id()}`).toggle();
  };

  self.hideOptionsMenu = function (item, event) {
    $(`#optMenu-${item.id()}`).hide();
  };

  self.execMenuOption = function (item, event, callback) {
    event.stopPropagation();
    callback(item, event);
    $(`#optMenu-${item.id()}`).toggle();
  };

  self.toggleRead = function (item, event) {
    let read = self.is_read();
    self.is_read(!read);

    let response = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.mark_as_messenger_conversation_path(self.id(), {state: (read ? 'unread' : 'read')})
    });

    response.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error(xhr.responseJSON);

      let read = self.is_read();
      self.is_read(!read);
    });

    event.stopPropagation();
  };

  self.blockParticipant = function (participant) {
    Kadenze.UIUtil.confirmAction(`Stop receiving messages from ${participant.full_name()}.`, function() {
      let blocked = participant.is_blocked();
      participant.is_blocked(!blocked);

      if (parent.mobileView())
        $(self.participantMobileOptsEl).modal('hide');

      let response = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.block_messenger_participant_path(participant.id())
      });

      response.done(function (response, status, xhr) {
        parent.updateParticipantInAllConversations(participant);
      });

      response.fail(function(xhr, status, msg) {
        let blocked = participant.is_blocked();
        participant.is_blocked(!blocked);
      });
    }, function() {

    }, {
      title: 'Block Messages?',
      cancel_btn_text: 'Cancel',
      ok_btn_text: 'Block Messages'
    });
  };

  self.unblockParticipant = function (participant, skip_confirmation) {
    let unblock = function () {
      let blocked = participant.is_blocked();
      participant.is_blocked(!blocked);

      if (parent.mobileView())
        $(self.participantMobileOptsEl).modal('hide');

      let response = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.unblock_messenger_participant_path(participant.id())
      });

      response.done(function (response, status, xhr) {
        parent.updateParticipantInAllConversations(participant);
      });

      response.fail(function(xhr, status, msg) {
        let blocked = participant.is_blocked();
        participant.is_blocked(!blocked);
      });
    };
    if (skip_confirmation === true) {
      unblock();
    } else {
      Kadenze.UIUtil.confirmAction(`You and ${participant.full_name()} will be able to send messages.`, unblock, null, {
        title: 'Unblock Messages?',
        cancel_btn_text: 'Cancel',
        ok_btn_text: 'Unblock Messages'
      });
    }
  };

  self.unblockFirstParticipant = function (skip_confirmation) {
    self.unblockParticipant(self.visibleParticipants()[0], skip_confirmation);
  };

  self.toggleFirstParticipantBlock = function () {
    if (self.visibleParticipants()[0].is_blocked()) {
      self.unblockParticipant(self.visibleParticipants()[0]);
    } else {
      self.blockParticipant(self.visibleParticipants()[0]);
    }
  };

  self.unblockOnSend = function () {
    Kadenze.UIUtil.confirmAction('Messages from this recipient are blocked. Please unblock messages from this recipient before sending them a message.', function () {
      self.unblockFirstParticipant(true);
      self.send();
    }, null, {
      title: 'Attention',
      cancel_btn_text: 'Cancel',
      ok_btn_text: 'Unblock'
    });
  };

  self.resetParticipantSearch = function () {
    self.addingParticipant(false);
    self.searchParticipant('');
    self.searchParticipantResults([]);
  };

  self.showAddParticipantView = function () {
    self.resetParticipantSearch();

    self.addingParticipant(true);
    $('#add_participant').focus();
  };

  self.initParticipantTypeahead = function () {
    let recipientSource = parent.recipientSource();

    ko.computed(function () {
      if (!_.isEmpty(self.searchParticipant()) && self.searchParticipant().length >= 1) {
        recipientSource.get(self.searchParticipant(), function (datums) {
          self.searchParticipantResults(ko.mapping.fromJS(datums)());
        });
      } else {
        self.searchParticipantResults([]);
      }
    });

    $('.msngr-main__body').off('click').on('click', function (e) {
      if (e.toElement.className == 'msngr-main__body') {
        self.resetParticipantSearch();
      }
    });
  };

  self.addParticipant = function (participant, event) {
    self.updated_at(moment().format(Kadenze.I18n.t('date.formats.js_default_with_zone')));

    let response = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.add_messenger_conversation_participant_path(self.id(), participant.id())
    });

    response.done(function (response, status, xhr) {
      let participants_mapping = {
        create: function(options) {
          return ko.mapping.fromJS(_.extend({}, options.data, {_destroy: false}));
        }
      };
      self.participants.push(ko.mapping.fromJS(response.participant, participants_mapping));

      let message = ko.mapping.fromJS(response.message);
      self.messages.push(message);

      self.deleteMessageCache();
    });

    response.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error(xhr.responseJSON);
    });

    response.always(function () {
      self.resetParticipantSearch();
    });
  };

  self.removeParticipant = function (participant) {
    Kadenze.UIUtil.confirmAction(`Are you sure you want to remove ${participant.full_name()} from this conversation?`, function() {
      let removed = participant._destroy();
      participant._destroy(!removed);

      self.updated_at(moment().format(Kadenze.I18n.t('date.formats.js_default_with_zone')));

      if (parent.mobileView())
        $(self.participantMobileOptsEl).modal('hide');

      let response = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.remove_messenger_conversation_participant_path(self.id(), participant.id())
      });

      response.done(function (response, status, xhr) {
        let message = ko.mapping.fromJS(response.message);
        self.messages.push(message);

        self.deleteMessageCache();
      });

      response.fail(function(xhr, status, msg) {
        let removed = participant._destroy();
        participant._destroy(!removed);
      });
    }, function() {

    });
  };

  self.showParticipantOptions = function (participant) {
    const $modal = $(self.participantMobileOptsEl);

    ko.cleanNode($modal[0]);

    participant.$parent = self;
    participant.$root = parent;

    ko.applyBindingsWithValidation(
      participant,
      $modal[0],
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    );

    $modal.modal('show');
  };

  self.getDropZoneFileType = function (ext) {
    return _.includes(self.allowedAttachmentTypes['image'].replace(/[\s,]+/g, ',').split(','), `.${ext}`) ? 'image' : 'file';
  };

  self.removeDropZoneFile = function (item, event) {
    self.dz.removeFile(item.dzFile);
  };

  self.initAttachmentDropZone = function(type, targetID) {
    let mp = null;
    let notice = null;
    let $modal = $(self.attachmentModalEl);
    let $dropArea = $(targetID);
    let fileTypes = self.allowedAttachmentTypes[type];
    let message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.file'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    let opts = {
      url: '/',
      autoProcessQueue: false,
      paramName: 'attachments',
      acceptedFiles: fileTypes,
      previewsContainer: '#dz-attachment-preview',
      previewTemplate: '<span></span>',
      maxFiles: 5,
      maxFilesize: 25,
      parallelUploads: 5,
      uploadMultiple: true,
      thumbnailWidth: 200,
      thumbnailHeight: 200,
    };

    let callbacks = {
      addedfile: function (file) {
        self.new_message.message_attachments.push({
          id: file.uuid,
          name: file.name,
          dzFile: file,
          thumb: ko.observable(),
          type: self.getDropZoneFileType(file.name.split('.').pop()),
          file: { square_thumb: { url: null } }
        });

        self.scrollToBottom();

        $modal.modal('hide');
      },
      removedfile: function (file) {
        self.new_message.message_attachments.remove(function (item) {
          return item.id == file.uuid;
        });
      },
      sendingmultiple: function (file, xhr, formData) {
        mp = new Mprogress({
          template: 2,
          start: true,
          parent: '#js-messages-loader'
        });
      },
      totaluploadprogress: function (progress) {
        if (mp && progress > 0 && progress < 100)
          mp.set(progress / 100);
      },
      complete: function (file) {
        if (self.dz)
          self.dz.removeFile(file);
      },
      completemultiple: function () {
        if (mp != null) {
          mp.end();
        }
      },
      error: function (file, errorMessage) {
        if (notice)
          notice.destroy();
        notice = new Kadenze.Notice.error({title: 'Sorry', message: errorMessage});
      },
      maxfilesexceeded: function (file) {
        //Empty callback to avoid the default behavior
      },
      thumbnail: function (file, data) {
        let index = _.findIndex(self.new_message.message_attachments(), function (item) {
          return item.id == file.uuid;
        });
        if (index > -1) {
          self.new_message.message_attachments()[index].file.square_thumb.url = data;
          self.new_message.message_attachments()[index].thumb(data);
        }
      }
    };

    return Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);
  };

  self.previewAttachment = function (item) {
    let obj = ko.mapping.toJS(item);
    if (obj.meta.streamable === true) {
      Kadenze.MediaFileActions.play(obj);
    } else {
      Kadenze.MediaFileActions.preview(obj);
    }
  };

  self.showNotice = function (message) {
    self.notice.message(message);
    self.notice.visible(true);
  };

  self.hideNotice = function () {
    self.notice.visible(false);
  };

  self.stopPropagation = function (item, event) {
    event.stopPropagation();
  };

  self.getActivityTemplate = function (item) {
    return item.type() ? ('activity_' + item.type().replace('Mailboxer::', '').toLowerCase() + '_template') : 'activity_message_template';
  };

  self.addSpacerTemplate = function (data, index) {
    return index() === 0 && (self.messagesMeta() && !self.messagesMeta().first_page());
  };

  self.addDateTemplate = function (data, index) {
    let prevMessage = self.messages()[index() - 1];
    return prevMessage && (moment(data.created_at()).format('ll') !== moment(prevMessage.created_at()).format('ll'));
  };

  self.getFormattedDateSeperator = function (data, index) {
    let formatted_date = null;
    let created_at = Kadenze.Util.getMomentDateFromObservable(data.created_at);
    if (moment().isSame(created_at, 'day')) {
      formatted_date = created_at.format('h:mm A');
    } else if (moment().diff(created_at, 'days') <= 7) {
      formatted_date = created_at.format('ddd, h:mm A');
    } else {
      formatted_date = created_at.format('MMM D, h:mm A');
    }
    return formatted_date;
  };

  self.isGroupedMessage = function (data, index) {
    let prevMessage = self.messages()[index() - 1];
    return prevMessage && (data.sender_id() === prevMessage.sender_id()) && (data.type() === prevMessage.type()) && (moment(data.created_at()).diff(prevMessage.created_at(), 'seconds') <= 60);
  };

  self.isPersistedId = function (id) {
    id = '' + id; //coerce num to be a string
    return !isNaN(id) && !isNaN(parseFloat(id));
  };

  self.lastPersistedMessageId = function (index) {
    return (self.messages()[index] && self.isPersistedId(self.messages()[index].id())) ? self.messages()[index].id() : (self.messages()[index - 1] ? self.lastPersistedMessageId(index - 1) : self.last_message_id());
  };

  self.getMessageBodyOrAttachmentName = function (message) {
    let txt = s.stripTags(message.body());
    txt = (_.isEmpty(txt) && (message.message_attachments().length > 0)) ? _.last(message.message_attachments()).name() : txt;
    return txt;
  };

  self.isRecent = ko.computed(function () {
    return moment().diff(moment(self.updated_at()), 'days') <= 7;
  });

  return self;
}
